export class MorayEastBidOfferPairDTO {
    public periodId: number;
    public startTime: string;
    public endTime:string;
    public minusOne_volume: number;
    public minusOne_mainBid: number;
    public minusOne_matchingOffer: number;
    public plusOne_volume: number;
    public plusOne_mainBid: number;
    public plusOne_matchingOffer: number;
}